export default __webpack_public_path__ + "static/media/user.ab16831a.svg";